module.exports = __webpack_public_path__ + "img/新入驻企业.05bf7c60.png";